// AdminContacts.jsx
import { useEffect, useState } from 'react';
import { getContacts } from '../../services/api';
import { Mail } from 'lucide-react';

export function AdminContacts() {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { getContacts().then(r => setContacts(r.data.contacts)).finally(() => setLoading(false)); }, []);

  return (
    <div className="space-y-5 animate-fade-up">
      <div><h1 className="text-2xl font-bold text-gray-900 font-heading">Contact Submissions</h1><p className="text-sm text-gray-500">{contacts.length} messages received</p></div>
      {loading ? <div className="text-center py-10 text-gray-400">Loading...</div> :
        contacts.length === 0 ? (
          <div className="card border border-gray-100 text-center py-14 text-gray-400"><Mail size={36} className="mx-auto mb-3 opacity-30" /><p>No messages yet.</p></div>
        ) : (
          <div className="space-y-4">
            {contacts.map(c => (
              <div key={c.id} className={`card border ${c.is_read ? 'border-gray-100' : 'border-purple-200 bg-purple-50/30'}`}>
                <div className="flex flex-wrap items-start justify-between gap-3 mb-3">
                  <div>
                    <p className="font-bold text-gray-900">{c.name}</p>
                    <p className="text-sm text-gray-500">{c.email} {c.phone && `· ${c.phone}`}</p>
                  </div>
                  <div className="text-right">
                    <p className="text-xs text-gray-400">{new Date(c.created_at).toLocaleString()}</p>
                    {!c.is_read && <span className="text-xs font-semibold text-purple-700 bg-purple-100 px-2 py-0.5 rounded-full">New</span>}
                  </div>
                </div>
                {c.subject && <p className="text-sm font-semibold text-gray-700 mb-1">{c.subject}</p>}
                <p className="text-sm text-gray-600 leading-relaxed">{c.message}</p>
                <div className="mt-3 flex gap-3">
                  <a href={`mailto:${c.email}`} className="text-xs text-purple-700 border border-purple-200 px-3 py-1.5 rounded-lg hover:bg-purple-50 transition-colors">Reply via Email</a>
                  {c.phone && <a href={`tel:${c.phone}`} className="text-xs text-gray-600 border border-gray-200 px-3 py-1.5 rounded-lg hover:bg-gray-50 transition-colors">Call</a>}
                </div>
              </div>
            ))}
          </div>
        )
      }
    </div>
  );
}

export default AdminContacts;
